module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-8-84f04c05679c18a9588add81fa448589.jpg";